import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth-guard.service';
import { SideMenuComponent } from './components/side-menu/side-menu.component';

const routes: Routes = [
  {
    path: 'side-menu',
    component: SideMenuComponent,
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginPageModule),
  },

  {
    path: 'list-detail/:id',
    loadChildren: () =>
      import('./modules/list-detail/list-detail.module').then(
        (m) => m.ListDetailModule
      ),
    // canActivate: [AuthGuard],
  },
  {
    path: 'list-detail-logos/:id',
    loadChildren: () =>
      import('./modules/list-detail-logos/list-detail-logos.module').then(
        (m) => m.ListDetailLogosModule
      ),
    // canActivate: [AuthGuard],
  },
  {
    path: 'item-list/:id',
    loadChildren: () =>
      import('./modules/item-list/item-list.module').then(
        (m) => m.ItemListModule
      ),
    // canActivate: [AuthGuard],
  },

  {
    path: 'simple-list/:id',
    loadChildren: () =>
      import('./modules/simple-list/simple-list.module').then(
        (m) => m.SimpleListModule
      ),
    // canActivate: [AuthGuard],
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('./modules/notifications/notifications.module').then(
        (m) => m.NotificationsModule
      ),
    // canActivate: [AuthGuard],
  },
  {
    path: 'feedback_form/:id',
    loadChildren: () =>
      import('./modules/feedback/feedback.module').then(
        (m) => m.FeedbackModule
      ),
    // canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'register',
    loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./modules/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'layout/:id',
    loadChildren: () => import('./layout/layout.module').then(m => m.LayoutPageModule)
  },
  {
    path: 'homepage/:id',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'cart',
    loadChildren: () => import('./modules/cart/cart.module').then(m => m.CartPageModule)
  },
  {
    path: 'page-menu',
    loadChildren: () => import('./page-menu/page-menu.module').then(m => m.PageMenuPageModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./modules/orders/orders.module').then(m => m.OrdersPageModule)
  },
  {
    path: 'contact/:id',
    loadChildren: () => import('./modules/contact/contact.module').then(m => m.ContactPageModule)
  },
  {
    path: 'add-shipment',
    loadChildren: () => import('./modules/add-shipment/add-shipment.module').then(m => m.AddShipmentPageModule)
  },
  {
    path: 'gallery/:id',
    loadChildren: () => import('./modules/gallery/gallery.module').then((m) => m.GalleryModule),
  },
  {
    path: 'my-courses',
    loadChildren: () => import('./modules/my-courses/my-courses.module').then(m => m.MyCoursesPageModule)
  },  {
    path: 'track-orders',
    loadChildren: () => import('./modules/track-orders/track-orders.module').then( m => m.TrackOrdersPageModule)
  },

  // {
  //   path: 'location',
  //   loadChildren: () => import('./modules/location/location.module').then( m => m.LocationPageModule)
  // },


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
